import styled from 'styled-components';

export const ProfileContainer = styled.div`
  max-width: 840px;
  margin: 0 auto;
  padding: 40px 20px 72px;
`;

export const ProfileHeader = styled.header`
  margin-bottom: 28px;

  .eyebrow {
    display: inline-block;
    background: var(--primary-subtle);
    color: var(--primary);
    font-size: var(--text-xs);
    font-weight: 700;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    padding: 4px 12px;
    border-radius: var(--radius-round);
    margin-bottom: 12px;
  }

  h1 {
    font-size: var(--text-3xl);
    letter-spacing: -0.5px;
    margin-bottom: 4px;
  }

  p {
    color: var(--text-secondary);
  }
`;

export const ProfileCard = styled.div`
  display: grid;
  grid-template-columns: 3fr 2fr;
  gap: 20px;
  margin-bottom: 36px;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;

export const ProfileSection = styled.section`
  background: var(--bg-card);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  padding: 26px;
  box-shadow: var(--shadow-xs);

  h2 {
    font-size: var(--text-lg);
  }

  .section-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;

    .edit-actions {
      display: flex;
      gap: 8px;
    }
  }

  > h2 {
    margin-bottom: 18px;
  }

  .feedback {
    background: var(--success-subtle);
    color: var(--success-dark);
    font-size: var(--text-sm);
    padding: 10px 14px;
    border-radius: var(--radius-md);
    margin-bottom: 14px;
  }

  .account-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
`;

export const BookingHistory = styled.section`
  h2 {
    font-size: var(--text-xl);
    margin-bottom: 16px;
  }
`;

export const BookingCard = styled.article`
  background: var(--bg-card);
  border: 1px solid var(--border-light);
  border-radius: var(--radius-lg);
  padding: 20px 24px;
  margin-bottom: 14px;
  box-shadow: var(--shadow-xs);
  transition: box-shadow var(--transition-fast);

  &:hover { box-shadow: var(--shadow-sm); }

  .booking-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 16px;
    margin-bottom: 10px;

    h3 {
      font-size: var(--text-lg);
      margin-bottom: 6px;
    }

    .booking-amount {
      font-size: var(--text-lg);
      font-weight: 700;
      color: var(--secondary);
      white-space: nowrap;
    }
  }

  .booking-details {
    p {
      font-size: var(--text-sm);
      color: var(--text-secondary);
      margin: 2px 0;
    }

    .booking-id {
      font-family: monospace;
      font-size: var(--text-xs);
      color: var(--text-muted);
    }
  }

  .booking-actions {
    display: flex;
    gap: 8px;
    margin-top: 14px;
  }
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 56px 20px;
  background: var(--bg-section);
  border: 1px dashed var(--border-medium);
  border-radius: var(--radius-lg);

  h3 { margin-bottom: 8px; }

  p {
    color: var(--text-secondary);
    font-size: var(--text-sm);
    margin-bottom: 20px;
  }
`;
